import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { FormControl, FormControlLabel, FormGroup, FormLabel } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Select from 'react-select';

import { createCenter, updateCenter, deleteCenter } from './../../ducks/centers';
import ConfirmDialog from '../../components/ConfirmDialog';
import { sportCenterAlterEnum } from './../../enums';
import RentalItemsManager from './RentalItemsManager';
import AdminPageShell from '../../components/admin/AdminPageShell';
import api from '../../lib/api';
import Link from '../../components/Link';
import { COUNTRY_SELECT_OPTIONS, normalizeCountryCode, resolveCountryCode } from '../../lib/countries';

export class SportCenter extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    centers: PropTypes.array,
    updateCenter: PropTypes.func.isRequired,
    createCenter: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    classes: PropTypes.object,
    deleteCenter: PropTypes.func.isRequired,
    timezoneList: PropTypes.array.isRequired,
    currentTimezone: PropTypes.object,
  };

  static defaultProps = {
    centers: [],
    classes: {},
    currentTimezone: null,
  };
  constructor(props) {
    super(props);

    const { match, centers } = this.props;
    const { id } = match.params;
    let centerModel;

    if (id) {
      centerModel = centers.find(i => i.id === id - 0);
    }

    const initialState = id
      ? {
          ...centerModel,
          countryCode: normalizeCountryCode(
            (centerModel && (centerModel.countryCode || centerModel.CountryCode)) || ''
          ) || '',
          mapDialogOpen: false,
          yclientsEnabled: false,
          yclientsCompanyId: '',
          yclientsWidgetFormId: '',
          yclientsStaffList: [],
          yclientsBindingsList: [],
          yclientsServicesList: [],
          yclientsServicesLoading: false,
          yclientsSaving: false,
          yclientsStaffLoading: false,
          yclientsBindingsSaving: false,
          yclientsError: null,
          yclientsSaved: false,
        }
        : {
          id,
          name: '',
          address: '',
          city: '',
          countryCode: '',
          description: '',
          latitude: '',
          longitude: '',
          parking: false,
          showers: false,
          chairlift: false,
          dragLift: false,
          lockers: false,
          poolBilliards: false,
          russianBilliards: false,
          snookerBilliards: false,
          ski: false,
          snowboard: false,
          rent: false,
          protection: false,
          inventory: false,
          toilets: false,
          type: 'Private',
          saveEnable: false,
          alter: 'Complex',
          timeZone: this.props.currentTimezone,
          mapDialogOpen: false,
        };
    
    this.state = initialState;
  }

  openConfirm = () => {
    this.setState({
      openConfirm: true,
    });
  }

  deleteCenter = async () => {
    const { id } = this.state;
    if (id) {
      await this.props.deleteCenter(id);
      this.props.history.push('/centers');
    }
    this.closeConfirm();
  }

  closeConfirm = () => {
    this.setState({ openConfirm: false });
  };

  openMapDialog = () => {
    this.setState({ mapDialogOpen: true });
  }

  closeMapDialog = () => {
    this.setState({ mapDialogOpen: false });
  }

  handleMapClick = async (lat, lng) => {
    this.setState({
      latitude: lat.toString(),
      longitude: lng.toString(),
    });
    this.closeMapDialog();
    try {
      const geo = await api.reverseGeocode(lat, lng);
      if (geo) {
        this.setState((prev) => ({
          city: geo.city || prev.city,
          countryCode: resolveCountryCode(geo) || prev.countryCode,
          address: geo.address || prev.address,
          saveEnable: !!(prev.name && (geo.address || prev.address)),
        }));
      }
    } catch (err) {
      console.warn('reverse geocode failed', err);
    }
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id) {
      this.loadYClientsSettings();
    }
  }

  loadYClientsSettings = async () => {
    const { id } = this.props.match.params;
    if (!id) return;
    try {
      const data = await api.getYClientsIntegration(id - 0);
      const list = (data.bindings || []).map(b => ({
        staffId: b.staffId || 0,
        playgroundId: b.playgroundId || 0,
        serviceId: b.serviceId != null ? b.serviceId : 0,
      }));
      this.setState({
        yclientsEnabled: data.enabled || false,
        yclientsCompanyId: data.companyId ? String(data.companyId) : '',
        yclientsWidgetFormId: data.widgetFormId != null ? String(data.widgetFormId) : '',
        yclientsBindingsList: list,
        yclientsError: null,
      });
    } catch (err) {
      this.setState({ yclientsError: err.message || 'Не удалось загрузить настройки YClients' });
    }
  }

  saveYClientsSettings = async () => {
    const { id } = this.props.match.params;
    if (!id) return;
    const { yclientsEnabled, yclientsCompanyId, yclientsWidgetFormId } = this.state;
    this.setState({ yclientsSaving: true, yclientsError: null, yclientsSaved: false });
    try {
      await api.putYClientsIntegration(id - 0, {
        enabled: yclientsEnabled,
        companyId: parseInt(yclientsCompanyId, 10) || 0,
        widgetFormId: yclientsWidgetFormId ? parseInt(yclientsWidgetFormId, 10) : null,
      });
      this.setState({ yclientsSaving: false, yclientsSaved: true });
      setTimeout(() => this.setState({ yclientsSaved: false }), 3000);
    } catch (err) {
      this.setState({
        yclientsSaving: false,
        yclientsError: err.message || 'Не удалось сохранить настройки',
      });
    }
  }

  loadYClientsStaff = async () => {
    const { id } = this.props.match.params;
    if (!id) return;
    this.setState({ yclientsStaffLoading: true, yclientsError: null });
    try {
      const list = await api.getYClientsStaff(id - 0);
      this.setState({ yclientsStaffList: list || [], yclientsStaffLoading: false });
    } catch (err) {
      this.setState({
        yclientsStaffLoading: false,
        yclientsError: err.message || 'Не удалось загрузить список сотрудников',
      });
    }
  }

  loadYClientsServices = async () => {
    const { id } = this.props.match.params;
    if (!id) return;
    this.setState({ yclientsServicesLoading: true, yclientsError: null });
    try {
      const list = await api.getYClientsServices(id - 0);
      this.setState({ yclientsServicesList: list || [], yclientsServicesLoading: false });
    } catch (err) {
      this.setState({
        yclientsServicesLoading: false,
        yclientsError: err.message || 'Не удалось загрузить список услуг. Проверьте сеть или попробуйте позже.',
      });
    }
  }

  setYClientsBindingRow = (index, field, value) => {
    this.setState((prev) => {
      const list = [...(prev.yclientsBindingsList || [])];
      if (!list[index]) return prev;
      list[index] = { ...list[index], [field]: value === '' || value == null ? 0 : parseInt(value, 10) };
      return { yclientsBindingsList: list };
    });
  }

  addYClientsBindingRow = () => {
    const { yclientsStaffList, yclientsServicesList } = this.state;
    const { playgrounds, match } = this.props;
    const complexId = match?.params?.id ? parseInt(match.params.id, 10) : 0;
    const pl = (playgrounds || []).filter(p => p.complexId === complexId);
    const firstStaff = (yclientsStaffList || [])[0];
    const firstPl = pl[0];
    const firstService = (yclientsServicesList || [])[0];
    this.setState((prev) => ({
      yclientsBindingsList: [
        ...(prev.yclientsBindingsList || []),
        {
          staffId: firstStaff ? firstStaff.id : 0,
          playgroundId: firstPl ? firstPl.id : 0,
          serviceId: firstService ? firstService.id : 0,
        },
      ],
    }));
  }

  removeYClientsBindingRow = (index) => {
    this.setState((prev) => {
      const list = [...(prev.yclientsBindingsList || [])];
      list.splice(index, 1);
      return { yclientsBindingsList: list };
    });
  }

  saveYClientsBindings = async () => {
    const { id } = this.props.match.params;
    if (!id) return;
    const { yclientsBindingsList } = this.state;
    const bindings = (yclientsBindingsList || [])
      .filter(b => b.playgroundId > 0 && b.serviceId > 0)
      .map(b => ({ staffId: b.staffId, playgroundId: b.playgroundId, serviceId: b.serviceId }));
    this.setState({ yclientsBindingsSaving: true, yclientsError: null });
    try {
      await api.putYClientsBindings(id - 0, bindings);
      this.setState({ yclientsBindingsSaving: false, yclientsSaved: true });
      setTimeout(() => this.setState({ yclientsSaved: false }), 3000);
    } catch (err) {
      this.setState({
        yclientsBindingsSaving: false,
        yclientsError: err.message || 'Не удалось сохранить привязки',
      });
    }
  }

  handleSelect = (value, name) => {
    this.setState({ [name]: value }, () => {
      this.setState({ saveEnable: this.validate() });
    });
  };

  handleCountrySelect = (selected) => {
    let code = null;
    if (typeof selected === 'string') {
      code = selected;
    } else if (selected && selected.value) {
      code = selected.value;
    }
    this.handleSelect(normalizeCountryCode(code), 'countryCode');
  };

  // Форматирование телефона: +[код страны] (XXX) XXX-XX-XX
  formatPhone = (value) => {
    if (!value) return '';
    // Убираем все нецифровые символы, кроме +
    let digits = value.replace(/[^\d+]/g, '');
    
    // Если не начинается с +, добавляем +
    if (!digits.startsWith('+')) {
      digits = '+' + digits;
    }
    
    // Ограничиваем длину (максимум 15 символов: + и до 14 цифр)
    if (digits.length > 15) {
      digits = digits.substring(0, 15);
    }
    
    // Если только +, возвращаем как есть
    if (digits.length <= 1) {
      return digits;
    }
    
    // Определяем код страны (1-3 цифры после +)
    const countryCodeMatch = digits.match(/^\+(\d{1,3})/);
    if (!countryCodeMatch) {
      return digits;
    }
    
    const countryCode = countryCodeMatch[1];
    const restDigits = digits.substring(countryCodeMatch[0].length);
    
    // Форматируем остальную часть номера
    if (restDigits.length === 0) {
      return `+${countryCode}`;
    } else if (restDigits.length <= 3) {
      return `+${countryCode} (${restDigits}`;
    } else if (restDigits.length <= 6) {
      return `+${countryCode} (${restDigits.substring(0, 3)}) ${restDigits.substring(3)}`;
    } else if (restDigits.length <= 8) {
      return `+${countryCode} (${restDigits.substring(0, 3)}) ${restDigits.substring(3, 6)}-${restDigits.substring(6)}`;
    } else {
      return `+${countryCode} (${restDigits.substring(0, 3)}) ${restDigits.substring(3, 6)}-${restDigits.substring(6, 8)}-${restDigits.substring(8)}`;
    }
  };

  // Обработчик изменения телефона с применением маски
  handlePhoneChange = (event) => {
    const inputValue = event.target.value;
    const cursorPosition = event.target.selectionStart;
    
    // Убираем все нецифровые символы, кроме +
    let digits = inputValue.replace(/[^\d+]/g, '');
    
    // Если не начинается с +, добавляем +
    if (!digits.startsWith('+')) {
      digits = '+' + digits;
    }
    
    // Ограничиваем длину (максимум 15 символов)
    if (digits.length > 15) {
      digits = digits.substring(0, 15);
    }
    
    // Сохраняем только цифры с + (без форматирования для хранения)
    this.setState({ description: digits }, () => {
      this.setState({ saveEnable: this.validate() });
      // Восстанавливаем позицию курсора после форматирования
      const formattedValue = this.formatPhone(digits);
      const input = event.target;
      setTimeout(() => {
        // Подсчитываем новую позицию курсора с учетом форматирования
        const beforeCursor = inputValue.substring(0, cursorPosition);
        const digitsBeforeCursor = beforeCursor.replace(/[^\d+]/g, '');
        let newCursorPos = digitsBeforeCursor.length;
        
        // Корректируем позицию с учетом форматирования
        if (digitsBeforeCursor.length > 1) {
          const countryCodeMatch = digitsBeforeCursor.match(/^\+(\d{1,3})/);
          if (countryCodeMatch) {
            const countryCodeLength = countryCodeMatch[0].length;
            const restLength = digitsBeforeCursor.length - countryCodeLength;
            
            if (restLength > 0) {
              newCursorPos = countryCodeLength + 2; // +XX (
              if (restLength > 3) {
                newCursorPos += 3 + 2; // +XX (XXX) 
                if (restLength > 6) {
                  newCursorPos += 3 + 1; // +XX (XXX) XXX-
                  if (restLength > 8) {
                    newCursorPos += 2 + 1; // +XX (XXX) XXX-XX-
                    newCursorPos += Math.min(restLength - 8, 2);
                  } else {
                    newCursorPos += restLength - 6;
                  }
                } else {
                  newCursorPos += restLength - 3;
                }
              } else {
                newCursorPos += restLength;
              }
            } else {
              newCursorPos = countryCodeLength;
            }
          }
        }
        
        if (newCursorPos > formattedValue.length) {
          newCursorPos = formattedValue.length;
        }
        input.setSelectionRange(newCursorPos, newCursorPos);
      }, 0);
    });
  };

  handleChange = (event, checked) => {
    if (event.target.type === 'checkbox') {
      this.setState({
        [event.target.name]: checked,
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }

    this.setState({ saveEnable: this.validate() });
  }

  submit = async () => {
    if (this.validate()) {
      if (this.state.id) {
        await this.props.updateCenter(this.state);
      } else {
        await this.props.createCenter(this.state);
      }
    } else {
      alert('Заполните необходимые поля'); // eslint-disable-line
    }

    this.props.history.push('/centers');
  }

  validate = () => {
    const { name, address } = this.state;
    return !!(name && address);
  }

  render() {
    const { classes, timezoneList } = this.props;
    const {
      openConfirm,
      id,
      saveEnable,
      name,
      address,
      description,
      latitude,
      longitude,
      type,
      lockers,
      showers,
      parking,
      alter,
      poolBilliards,
      ski,
      chairlift,
      dragLift,
      russianBilliards,
      snookerBilliards,
      snowboard,
      protection,
      inventory,
      rent,
      city,
      countryCode,
      timeZone,
      yclientsEnabled,
      yclientsCompanyId,
      yclientsWidgetFormId,
      yclientsStaffList,
      yclientsBindingsList,
      yclientsServicesList,
      yclientsServicesLoading,
      yclientsSaving,
      yclientsStaffLoading,
      yclientsBindingsSaving,
      yclientsError,
      yclientsSaved,
    } = this.state;

    const isNew = !id;

    return (
      <AdminPageShell
        beforeHeader={
          <Button
            className={classes.backButton}
            onClick={() => {
              if (this.props.history) this.props.history.push('/centers');
            }}
          >
            ← К списку центров
          </Button>
        }
        title={isNew ? 'Новый спортивный центр' : 'Редактирование спортцентра'}
        actions={
          <>
            {!isNew && (
              <Button
                variant="outlined"
                color="primary"
                onClick={() => this.props.history.push(`/sections?centerId=${encodeURIComponent(String(id))}`)}
                className={classes.outlinedButton}
              >
                Секции
              </Button>
            )}
            {!isNew && (
              <Button
                variant="contained"
                color="secondary"
                onClick={this.openConfirm}
                className={classes.removeButton}
              >
                Удалить
              </Button>
            )}
            <Button
              disabled={!saveEnable}
              variant="contained"
              color="primary"
              onClick={this.submit}
              className={classes.button}
            >
              {isNew ? 'Создать' : 'Сохранить'}
            </Button>
          </>
        }
      >
      <div className={classes.pageBody}>
        <Paper className={classes.paperImages} elevation={2}>
          <div className={classes.content}>
          <TextField
            required
            name="name"
            value={name || ''}
            label="Название"
            className={classes.field}
            onChange={this.handleChange}
            fullWidth
          />
          <TextField
            required
            onChange={this.handleChange}
            label="Город"
            name="city"
            value={city || ''}
            className={classes.field}
            fullWidth
          />
          <div className={classes.field}>
            <InputLabel>Страна</InputLabel>
            <Select
              name="countryCode"
              value={COUNTRY_SELECT_OPTIONS.find(option => option.value === countryCode) || null}
              options={COUNTRY_SELECT_OPTIONS}
              onChange={this.handleCountrySelect}
              clearable
              placeholder="Начните вводить название"
              noResultsText="Не найдено"
            />
          </div>
          <TextField
            required
            onChange={this.handleChange}
            label="Адрес"
            name="address"
            value={address || ''}
            className={classes.field}
            fullWidth
          />
          <Select
            name="timeZone"
            value={timeZone ? timeZone.id : null}
            options={timezoneList.map(timezone => ({
              value: timezone.id,
              label: timezone.localizedName,
            }))}
            onChange={selected => this.handleSelect(selected ? {
              id: selected.value,
            } : null, 'timeZone')}
            className={classes.field}
            clearable={false}
            multi={false}
            placeholder="Часовой пояс"
            noResultsText="Не найдено"
          />
          <TextField
            name="description"
            onChange={this.handlePhoneChange}
            label="Телефон"
            value={this.formatPhone(description || '')}
            placeholder="+[код страны] (XXX) XXX-XX-XX"
            className={classes.field}
            fullWidth
            helperText="Формат: +[код страны] (XXX) XXX-XX-XX"
          />
          <FormGroup row className={classes.formGroupRow}>
            <TextField
              name="latitude"
              value={latitude || ''}
              onChange={this.handleChange}
              label="Широта"
              className={classes.fieldShort}
              fullWidth={false}
            />
            <TextField
              name="longitude"
              value={longitude || ''}
              onChange={this.handleChange}
              label="Долгота"
              className={classes.fieldShort}
              fullWidth={false}
            />
            <Button
              variant="outlined"
              onClick={this.openMapDialog}
              className={classes.outlinedButton}
              style={{ marginTop: 10, marginLeft: 16 }}
            >
              <span role="img" aria-label="Маркер на карте">📍</span> Отметить на карте
            </Button>
          </FormGroup>
          <Divider className={classes.divider} />
          <FormControl component="fieldset" required className={classes.formControl}>
            <FormLabel component="legend" className={classes.formLabel}>Тип спортивного центра</FormLabel>
            <RadioGroup
              name="type"
              value={type}
              className={classes.radioGroup}
              onChange={this.handleChange}
            >
              <FormControlLabel value="Private" control={<Radio />} label="Частный" />
              <FormControlLabel value="Public" control={<Radio />} label="Общественный" />
            </RadioGroup>
          </FormControl>
          <FormControl component="fieldset" required className={classes.formControl}>
            <FormLabel component="legend" className={classes.formLabel}>Категория</FormLabel>
            <RadioGroup
              name="alter"
              value={alter}
              className={classes.radioGroup}
              onChange={this.handleChange}
            >
              <FormControlLabel value={sportCenterAlterEnum.pool} control={<Radio />} label="Бильярд" />
              <FormControlLabel value={sportCenterAlterEnum.snow} control={<Radio />} label="ГСК" />
              <FormControlLabel value={sportCenterAlterEnum.complex} control={<Radio />} label="Спорткомплекс" />
              <FormControlLabel value={sportCenterAlterEnum.rental} control={<Radio />} label="Магазин проката" />
            </RadioGroup>
          </FormControl>
          <FormControl component="fieldset" className={classes.formControl}>
            <FormLabel component="legend" className={classes.formLabel}>
              Дополнительно
            </FormLabel>
            <FormGroup row className={classes.checkboxesGroup}>
              {alter !== sportCenterAlterEnum.rental && alter !== sportCenterAlterEnum.pool && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={lockers}
                      onChange={this.handleChange}
                      name="lockers"
                    />
                  }
                  label="Раздевалки"
                />
              )}
              {alter === sportCenterAlterEnum.pool && (
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={poolBilliards}
                        onChange={this.handleChange}
                        name="poolBilliards"
                      />
                    }
                    label="Пул"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={russianBilliards}
                        onChange={this.handleChange}
                        name="russianBilliards"
                      />
                    }
                    label="Русский бильярд"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={snookerBilliards}
                        onChange={this.handleChange}
                        name="snookerBilliards"
                      />
                    }
                    label="Снукер"
                  />
                </div>
              )}
              {alter === sportCenterAlterEnum.snow && (
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={chairlift}
                        onChange={this.handleChange}
                        name="chairlift"
                      />
                    }
                    label="Кресельный подъемник"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={dragLift}
                        onChange={this.handleChange}
                        name="dragLift"
                      />
                    }
                    label="Бугельный подъемник"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={rent}
                        onChange={this.handleChange}
                        name="rent"
                      />
                    }
                    label="Прокат"
                  />
                </div>
              )}
              {alter === sportCenterAlterEnum.rental && (
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={ski}
                        onChange={this.handleChange}
                        name="ski"
                      />
                    }
                    label="Лыжи"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={snowboard}
                        onChange={this.handleChange}
                        name="snowboard"
                      />
                    }
                    label="Сноуборд"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={protection}
                        onChange={this.handleChange}
                        name="protection"
                      />
                    }
                    label="Защита"
                  />
                </div>
              )}
              {
                alter !== sportCenterAlterEnum.rental &&
                alter !== sportCenterAlterEnum.pool &&
                alter !== sportCenterAlterEnum.snow && (
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showers}
                        onChange={this.handleChange}
                        name="showers"
                      />
                    }
                    label="Душевые"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={inventory}
                        onChange={this.handleChange}
                        name="inventory"
                      />
                    }
                    label="Инвентарь"
                  />
                </div>
              )}
              {alter !== sportCenterAlterEnum.snow && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={parking}
                      onChange={this.handleChange}
                      name="parking"
                    />
                  }
                  label="Парковка"
                />
              )}
            </FormGroup>
          </FormControl>
          </div>
        </Paper>
        {id && (
          <Paper className={classes.paperImages} elevation={2} style={{ marginTop: 24 }}>
            <div className={classes.content}>
              <Typography variant="h6" style={{ marginBottom: 8 }}>Сотрудники организации</Typography>
              <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                Владелец и админы объектов живут на организации, не на карточке клуба.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to={`/organization/staff?complexId=${id}`}
              >
                Открыть сотрудников
              </Button>
            </div>
          </Paper>
        )}
        {id && (
          <Paper className={classes.paperImages} elevation={2} style={{ marginTop: 24 }}>
            <div className={classes.content}>
              <Typography variant="h6" style={{ marginBottom: 16 }}>Интеграция YClients</Typography>
              <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                Расписание для площадок этого центра можно подгружать из YClients. Укажите Company ID и ID формы виджета (из URL формы записи, например n1968394.yclients.com → 1968394).
              </Typography>
              {yclientsError && (
                <Typography color="error" style={{ marginBottom: 8 }}>{yclientsError}</Typography>
              )}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={yclientsEnabled}
                    onChange={(e) => this.setState({ yclientsEnabled: e.target.checked })}
                    name="yclientsEnabled"
                  />
                }
                label="Использовать расписание из YClients"
              />
              <TextField
                name="yclientsCompanyId"
                value={yclientsCompanyId ?? ''}
                onChange={(e) => this.setState({ yclientsCompanyId: e.target.value })}
                label="Company ID (YClients)"
                className={classes.field}
                fullWidth
                type="number"
                inputProps={{ min: 0 }}
              />
              <TextField
                name="yclientsWidgetFormId"
                value={yclientsWidgetFormId ?? ''}
                onChange={(e) => this.setState({ yclientsWidgetFormId: e.target.value })}
                label="ID формы виджета (WidgetFormId)"
                className={classes.field}
                fullWidth
                type="number"
                placeholder="Например: 1968394"
                helperText="Из URL формы записи: n123456.yclients.com → 123456"
              />
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 8, alignItems: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.saveYClientsSettings}
                  disabled={yclientsSaving}
                  style={{ marginRight: 12, marginBottom: 8 }}
                >
                  {yclientsSaving ? 'Сохранение…' : 'Сохранить настройки YClients'}
                </Button>
                <Button
                  variant="outlined"
                  onClick={this.loadYClientsStaff}
                  disabled={yclientsStaffLoading || !yclientsCompanyId}
                  style={{ marginRight: 12, marginBottom: 8 }}
                >
                  {yclientsStaffLoading ? 'Загрузка…' : 'Загрузить сотрудников'}
                </Button>
                <Button
                  variant="outlined"
                  onClick={this.loadYClientsServices}
                  disabled={yclientsServicesLoading || !yclientsCompanyId}
                  style={{ marginRight: 12, marginBottom: 8 }}
                >
                  {yclientsServicesLoading ? 'Загрузка…' : 'Загрузить услуги'}
                </Button>
                {yclientsServicesList.length > 0 && (
                  <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                    Загружено услуг: {yclientsServicesList.length}
                    {yclientsServicesList.slice(0, 5).map(svc => ` «${svc.title || 'Услуга'}»${svc.priceMin != null ? ` ${svc.priceMin} ₽` : ''}`).join('; ')}
                    {yclientsServicesList.length > 5 ? ' …' : ''}
                  </Typography>
                )}
                {yclientsSaved && <Typography color="primary" style={{ marginBottom: 8 }}>Сохранено</Typography>}
              </div>
              {yclientsStaffList.length > 0 && (
                <div style={{ marginTop: 24 }}>
                  <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                    Привязки площадок к YClients (площадка + сотрудник + услуга)
                  </Typography>
                  <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
                    У одной площадки может быть несколько привязок (разные услуги/тарифы). Загрузите сотрудников и услуги, затем добавьте строки и выберите площадку, сотрудника и услугу. Услуга обязательна для расписания и цены.
                  </Typography>
                  {(this.props.playgrounds || []).filter(p => p.complexId === parseInt(id, 10)).length === 0 && (
                    <Typography color="error" style={{ marginBottom: 8 }}>
                      Сначала создайте площадки для этого центра (блок «Прокат» ниже или раздел площадок).
                    </Typography>
                  )}
                  <div style={{ marginBottom: 12 }}>
                    {(yclientsBindingsList || []).map((row, idx) => {
                      const complexPlaygrounds = (this.props.playgrounds || []).filter(p => p.complexId === parseInt(id, 10));
                      const playgroundOptions = [
                        { value: '', label: '— Площадка —' },
                        ...complexPlaygrounds.map(p => ({ value: String(p.id), label: p.name || `Площадка ${p.id}` })),
                      ];
                      const staffOptions = [
                        { value: '', label: '— Сотрудник —' },
                        ...(yclientsStaffList || []).map(s => ({ value: String(s.id), label: `${s.name}${s.specialization ? ` — ${s.specialization}` : ''} (id: ${s.id})` })),
                      ];
                      const serviceOptions = [
                        { value: '', label: '— Услуга —' },
                        ...(yclientsServicesList || []).map(svc => ({
                          value: String(svc.id),
                          label: `${svc.title || 'Услуга'} (id: ${svc.id})${svc.priceMin != null ? ` — ${svc.priceMin} ₽` : ''}`,
                        })),
                      ];
                      const plVal = row.playgroundId ? String(row.playgroundId) : '';
                      const staffVal = row.staffId ? String(row.staffId) : '';
                      const svcVal = row.serviceId ? String(row.serviceId) : '';
                      const selectedPl = plVal ? (playgroundOptions.find(o => o.value === plVal) || { value: plVal, label: `Площадка ${plVal}` }) : playgroundOptions[0];
                      const selectedStaff = staffVal ? (staffOptions.find(o => o.value === staffVal) || { value: staffVal, label: `Сотрудник ${staffVal}` }) : staffOptions[0];
                      const selectedSvc = svcVal ? (serviceOptions.find(o => o.value === svcVal) || { value: svcVal, label: `Услуга ${svcVal}` }) : serviceOptions[0];
                      return (
                        <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 8, flexWrap: 'wrap', gap: 12 }}>
                          <Select
                            value={selectedPl}
                            options={playgroundOptions}
                            onChange={(selected) => this.setYClientsBindingRow(idx, 'playgroundId', selected ? selected.value : '')}
                            className={classes.field}
                            style={{ minWidth: 180 }}
                            placeholder="Площадка"
                            noResultsText="Нет площадок"
                          />
                          <Select
                            value={selectedStaff}
                            options={staffOptions}
                            onChange={(selected) => this.setYClientsBindingRow(idx, 'staffId', selected ? selected.value : '')}
                            className={classes.field}
                            style={{ minWidth: 220 }}
                            placeholder="Сотрудник"
                            noResultsText="Загрузите сотрудников"
                          />
                          <Select
                            value={selectedSvc}
                            options={serviceOptions}
                            onChange={(selected) => this.setYClientsBindingRow(idx, 'serviceId', selected ? selected.value : '')}
                            className={classes.field}
                            style={{ minWidth: 240 }}
                            placeholder="Услуга"
                            noResultsText="Загрузите услуги"
                          />
                          <Button
                            size="small"
                            color="secondary"
                            onClick={() => this.removeYClientsBindingRow(idx)}
                            title="Удалить строку"
                          >
                            Удалить
                          </Button>
                        </div>
                      );
                    })}
                  </div>
                  <Button
                    variant="outlined"
                    size="small"
                    color="primary"
                    onClick={this.addYClientsBindingRow}
                    style={{ marginRight: 12 }}
                  >
                    Добавить привязку
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.saveYClientsBindings}
                    disabled={yclientsBindingsSaving}
                  >
                    {yclientsBindingsSaving ? 'Сохранение…' : 'Сохранить привязки'}
                  </Button>
                  {yclientsSaved && <Typography component="span" color="primary" style={{ marginLeft: 12 }}>Сохранено</Typography>}
                </div>
              )}
            </div>
          </Paper>
        )}
        {id && (
          <RentalItemsManager
            complexId={id}
            playgrounds={this.props.playgrounds || []}
          />
        )}
      </div>
        <ConfirmDialog
          open={openConfirm}
          onClose={this.closeConfirm}
          onConfirm={this.deleteCenter}
          text="Вы действительно хотите удалить спортивный центр?"
        />
        <MapDialog
          open={this.state.mapDialogOpen}
          onClose={this.closeMapDialog}
          onMapClick={this.handleMapClick}
          initialLat={latitude ? parseFloat(latitude) : null}
          initialLng={longitude ? parseFloat(longitude) : null}
          classes={classes}
        />
      </AdminPageShell>
    );
  }
}

// Компонент диалога с картой Google Maps
class MapDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onMapClick: PropTypes.func.isRequired,
    initialLat: PropTypes.number,
    initialLng: PropTypes.number,
    classes: PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.map = null;
    this.marker = null;
    this.mapInitialized = false;
    this.state = {
      hasMarker: false,
    };
  }

  componentDidMount() {
    this.loadGoogleMaps();
  }

  loadGoogleMaps = () => {
    // Загружаем Google Maps API если еще не загружен
    if (window.google && window.google.maps) {
      if (this.props.open) {
        setTimeout(() => this.initMap(), 100);
      }
      return;
    }

    // Проверяем, не загружается ли уже скрипт
    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      // Скрипт уже загружается, ждем его загрузки
      const checkGoogle = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(checkGoogle);
          if (this.props.open) {
            setTimeout(() => this.initMap(), 100);
          }
        }
      }, 100);
      return;
    }

    const script = document.createElement('script');
    // Используйте переменную окружения REACT_APP_GOOGLE_MAPS_API_KEY для API ключа
    // Для разработки можно использовать без ключа, но функциональность будет ограничена
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
    const callbackName = `initGoogleMap_${Date.now()}`;
    
    // Создаем уникальную функцию обратного вызова
    window[callbackName] = () => {
      if (this.props.open) {
        setTimeout(() => this.initMap(), 100);
      }
      // Удаляем функцию после использования
      delete window[callbackName];
    };
    
    const scriptSrc = apiKey 
      ? `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=${callbackName}`
      : `https://maps.googleapis.com/maps/api/js?libraries=places&callback=${callbackName}`;
    
    script.src = scriptSrc;
    script.async = true;
    script.defer = true;
    
    script.onerror = () => {
      console.error('Не удалось загрузить Google Maps API. Убедитесь, что у вас есть валидный API ключ в переменной окружения REACT_APP_GOOGLE_MAPS_API_KEY.');
      delete window[callbackName];
    };
    
    document.head.appendChild(script);
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      // Диалог открылся, сбрасываем состояние маркера
      this.setState({ hasMarker: false });
      this.mapInitialized = false;
      this.marker = null;
      this.map = null;
      
      // Инициализируем карту
      if (window.google && window.google.maps) {
        setTimeout(() => {
          if (this.mapRef.current) {
            this.initMap();
          }
        }, 100);
      } else {
        // Если API еще не загружен, загружаем его
        this.loadGoogleMaps();
      }
    }
    
    // Если диалог закрылся, сбрасываем состояние
    if (!this.props.open && prevProps.open) {
      this.setState({ hasMarker: false });
      this.mapInitialized = false;
      this.marker = null;
      this.map = null;
    }
  }

  initMap = () => {
    if (!this.mapRef.current || !window.google || !window.google.maps || this.mapInitialized) {
      return;
    }

    const { initialLat, initialLng } = this.props;
    
    // Центр по умолчанию - Москва
    const defaultCenter = { lat: 55.7558, lng: 37.6173 };
    const center = (initialLat && initialLng) 
      ? { lat: initialLat, lng: initialLng }
      : defaultCenter;

    // Создаем карту
    this.map = new window.google.maps.Map(this.mapRef.current, {
      center: center,
      zoom: (initialLat && initialLng) ? 15 : 10,
      mapTypeControl: true,
      streetViewControl: true,
      fullscreenControl: true,
    });

    this.mapInitialized = true;

    // Добавляем маркер если есть начальные координаты
    if (initialLat && initialLng) {
      this.marker = new window.google.maps.Marker({
        position: { lat: initialLat, lng: initialLng },
        map: this.map,
        draggable: true,
      });
      this.setState({ hasMarker: true });
    }

    // Обработчик клика на карте
    this.map.addListener('click', (event) => {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      
      // Обновляем или создаем маркер
      if (this.marker) {
        this.marker.setPosition({ lat, lng });
      } else {
        this.marker = new window.google.maps.Marker({
          position: { lat, lng },
          map: this.map,
          draggable: true,
        });
        this.setState({ hasMarker: true });
      }
    });
  }

  handleSave = () => {
    if (this.marker) {
      const position = this.marker.getPosition();
      this.props.onMapClick(position.lat(), position.lng());
    }
    this.props.onClose();
  }

  render() {
    const { open, onClose, classes } = this.props;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            minHeight: '500px',
          },
        }}
      >
        <DialogTitle>Выберите местоположение на карте</DialogTitle>
        <DialogContent style={{ padding: 0, minHeight: '500px' }}>
          <div
            ref={this.mapRef}
            style={{
              width: '100%',
              height: '500px',
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} className={classes?.outlinedButton}>
            Отмена
          </Button>
          <Button
            onClick={this.handleSave}
            variant="contained"
            color="primary"
            className={classes?.button}
            disabled={!this.state.hasMarker}
          >
            Сохранить координаты
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  paper: {
    overflowX: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    alignItems: 'stretch',
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    backgroundColor: '#ffffff',
    transition: 'box-shadow 0.3s ease',
    marginBottom: theme.spacing(2),
    boxSizing: 'border-box',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
  },
  paperImages: {
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    alignItems: 'stretch',
    marginTop: 0,
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    backgroundColor: '#ffffff',
    transition: 'box-shadow 0.3s ease',
    boxSizing: 'border-box',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
  },
  pageBody: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    width: '100%',
    padding: 0,
    boxSizing: 'border-box',
    minHeight: 0,
  },
  backButton: {
    alignSelf: 'flex-start',
    marginLeft: theme.spacing(-1),
    paddingTop: 4,
    paddingBottom: 4,
    textTransform: 'none',
    fontWeight: 500,
    color: '#000000',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  flex: {
    flex: 1,
  },
  field: {
    marginLeft: 0,
    marginRight: 0,
    width: '100%',
    marginTop: theme.spacing(2),
    overflow: 'visible',
    boxSizing: 'border-box',
    '& .MuiInputLabel-formControl': {
      position: 'relative',
      transform: 'none !important',
      transformOrigin: 'top left',
      top: 0,
      left: 0,
      fontSize: '0.875rem',
      marginBottom: 4,
      whiteSpace: 'nowrap',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'none !important',
    },
    '& .MuiInput-formControl': {
      marginTop: 0,
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#1976d2',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: 2,
      },
    },
    '& .Select': {
      width: '100%',
    },
    '& .Select-control': {
      width: '100%',
    },
  },
  fieldShort: {
    marginLeft: 0,
    marginRight: 0,
    marginTop: 10,
    flex: 1,
    boxSizing: 'border-box',
    '&:first-of-type': {
      marginRight: theme.spacing(2),
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#1976d2',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: 2,
      },
    },
  },
  checkboxes: {
    marginLeft: 0,
    marginRight: 0,
    marginTop: 10,
  },
  checkboxesGroup: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  formControl: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  formLabel: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#495057',
  },
  formGroupRow: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  radioSet: {
    marginTop: 15,
    marginLeft: 0,
    marginRight: 0,
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  removeButton: {
    borderRadius: 8,
    padding: theme.spacing(1.25, 3),
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    marginRight: theme.spacing(2.5),
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
  },
  button: {
    borderRadius: 8,
    padding: theme.spacing(1.25, 3),
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    whiteSpace: 'nowrap',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
    '&:disabled': {
      opacity: 0.6,
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
      color: 'rgba(0, 0, 0, 0.26)',
    },
    '& .MuiButton-label': {
      whiteSpace: 'nowrap',
    },
  },
  outlinedButton: {
    borderRadius: 8,
    padding: theme.spacing(1.25, 3),
    fontWeight: 600,
    textTransform: 'none',
    borderWidth: 2,
    '&:hover': {
      borderWidth: 2,
    },
  },
  content: {
    boxSizing: 'border-box',
    padding: 0,
  },
});

const Styled = withStyles(styles)(SportCenter);

export default connect(
  state => ({
    centers: state.centers,
    playgrounds: state.playgrounds,
    timezoneList: state.timezone.list,
    currentTimezone: state.timezone.current,
  }),
  { updateCenter, createCenter, deleteCenter }
)(Styled);
